import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import './DashboardBillView.scss';
import { dashboardFnbBillsListSelector, fetchAllDashboardFnbList } from '../../DashboardSlice';
import LinearProgressBar from '../../../../shared/progress-bar/Progress';
import { selectedHotelCurrencySelector } from '../../../property/propertySlice';
import { payFnBDashboardBIll } from '../../../../utils/dashboardAPIUtils';
import { generatedElapsedTime } from '../../../../utils/dashboardUtils';

const DashboardBillView = (props) => {
  const { obj, onViewToggle, hotelId } = props;
  const dispatch = useDispatch();
  const allDashboardFnBBillList = useSelector(dashboardFnbBillsListSelector);
  const currency = useSelector(selectedHotelCurrencySelector);
  const [bill, setBill] = useState(null);
  const [elapsed, setElapsed] = useState(true);
  const [itemsCount, setItemsCount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [second, setSecond] = useState(0);

  useEffect(() => {
    const currBill = allDashboardFnBBillList.find(
      (dashboardBillList) => dashboardBillList.id === obj.id,
    );
    if (currBill) setBill(currBill);
  }, [obj, allDashboardFnBBillList]);

  const getTimeDifference = (time, startTime) => {
    const startDate = startTime ? moment.unix(startTime) : moment();
    const endDate = moment.unix(time);
    const timeDifference = generatedElapsedTime(startDate, endDate);
    return timeDifference;
  };

  useEffect(() => {
    if (bill) {
      let timeDifference = 0;
      let timer = null;
      if (bill.orderStatus !== 'Completed') {
        timer = setTimeout(() => {
          timeDifference = getTimeDifference(bill?.createdAt);
          setSecond(second + 1);
          setElapsed(timeDifference);
        }, 1000);
      } else {
        timeDifference = getTimeDifference(bill?.completedTime, bill?.createdAt);
        setElapsed(timeDifference);
      }

      if (bill.orders.length > 0) {
        let items = [];
        let amount = 0;
        for (let i = 0; i < bill.orders.length; i++) {
          for (let j = 0; j < bill.orders[i].items.length; j++) {
            items.push(bill.orders[i].items[j]);
            amount = amount + bill.orders[i].items[j].amount * bill.orders[i].items[j].count;
          }
        }
        setItemsCount(items.length);
        setTotalAmount(amount);
      }
      return () => clearTimeout(timer);
    }
  }, [bill, second]);

  const onClickBack = () => {
    onViewToggle('', false, null, true);
  };

  const viewDate = (date) => {
    return moment.unix(date).format('DD MMM, hh:mm A');
  };

  const handleBillPaid = async () => {
    await payFnBDashboardBIll(obj.id, hotelId, obj.restaurantId);
    await dispatch(fetchAllDashboardFnbList(hotelId, obj.restaurantId));
  };

  return (
    <>
      {elapsed === null ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <div className='ird-dashboard-view container mt-4 mb-3 detail-view-65 pb-4'>
          <div className='mt-5 row mx-0'>
            <div className='col-md-12 px-0 d-flex align-items-center'>
              <Button
                variant='text'
                color='secondary'
                size='small'
                startIcon={<ArrowBack />}
                onClick={(e) => onClickBack()}
                className='me-2'
              >
                Back
              </Button>
              <span className='page-title'>Table {('0' + bill?.tableNumber).slice(-2)}</span>
            </div>
          </div>
          <div className='card shadow mt-4 mb-4 pb-5 h-100 px-4 pt-4'>
            <div className='row mb-4'>
              <div className='col-md-4'>
                <div className='details-label'>Bill Id</div>
                <div className='details-value'>{bill?.id}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Table No</div>
                <div className='details-value'>{('0' + bill?.tableNumber).slice(-2)}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Status</div>
                <div className={`status ${bill?.statusClass}`}>{bill?.orderStatus}</div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-4'>
                <div className='details-label'>Guest name</div>
                <div className='details-value'>{bill?.guestName}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Date & Time</div>
                <div className='details-value'>{viewDate(bill?.createdAt)}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Time Elapsed</div>
                <div className='details-value'>{elapsed}</div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-4'>
                <div className='details-label'>No of Items ordered</div>
                <div className='details-value'>{('0' + itemsCount).slice(-2)}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>Guest Type</div>
                <div className='details-value'>{bill?.guestType}</div>
              </div>
              <div className='col-md-4'>
                <div className='details-label'>No of Guests</div>
                <div className='details-value'> {('0' + bill?.noOfGuests).slice(-2)}</div>
              </div>
            </div>
            <div className='row mb-4'>
              <div className='col-md-4'>
                <div className='details-label'>Payment Method</div>
                <div className='details-value'>
                  {bill?.paymentMethod !== '' ? bill?.paymentMethod : 'Cash'}
                </div>
              </div>
            </div>
            <div className='row'>
              <div className='col-md-10'>
                {bill?.orders?.map((currentOrder, orderKey) => (
                  <div key={orderKey}>
                    <div className='details-label mb-2'>Order id #{currentOrder.id}</div>
                    {currentOrder.items?.map((currentItem, key) => (
                      <div key={key}>
                        <Accordion className='mb-2'>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            id='panel1a-header'
                            className='accordion-summary'
                          >
                            <Typography
                              sx={{
                                width: '60%',
                                flexShrink: 0,
                                color: '#707070',
                                fontSize: '16px',
                              }}
                            >
                              {currentItem?.name}
                            </Typography>
                            <Typography
                              sx={{ width: '20%', flexShrink: 0 }}
                              className='accordion-summary-text'
                            >
                              x {currentItem?.count}
                            </Typography>
                            <Typography
                              sx={{ width: '20%', flexShrink: 0 }}
                              className='accordion-summary-text'
                            >
                              {currency} {currentItem?.count * currentItem?.amount}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails className='accordion-details'>
                            <div className='row'>
                              <div className='col-md-2'>
                                {currentItem.image && (
                                  <img
                                    src={currentItem.image}
                                    alt='user'
                                    className={currentItem?.name}
                                  />
                                )}
                              </div>
                              <div className='col-md-10'>
                                <div className='row'>
                                  <div className='col-md-3'>Add Ons:</div>
                                  <div className='col-md-9 details-text'>
                                    {currentItem.addons?.map((addon) => addon.name).join(',')}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-md-3'>Customisations:</div>
                                  <div className='col-md-9 details-text'>
                                    {currentItem.customisations
                                      ?.map((customisations) => customisations.name)
                                      .join(',')}
                                  </div>
                                </div>
                                <div className='row'>
                                  <div className='col-md-3'>Cooking Instructions:</div>
                                  <div className='col-md-9 details-text'>
                                    {currentItem.cookingInstructions}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </div>
            <div className='row mt-5 col-md-10'>
              <div className='accordion-details MuiPaper-root MuiPaper-elevation MuiPaper-rounded MuiPaper-elevation1 MuiAccordion-root MuiAccordion-rounded Mui-expanded MuiAccordion-gutters mb-2 css-1elwnq4-MuiPaper-root-MuiAccordion-root'>
                <div className='details-label mb-2'>Bill Summary</div>
                <div className='row amount-section'>
                  <div className='col-md-10'>Subtotal</div>
                  <div className='col-md-2'>
                    {currency} {totalAmount}
                  </div>
                </div>
                <div className='row amount-section'>
                  <div className='col-md-10'>Tip</div>
                  <div className='col-md-2'>
                    + {currency} {bill?.tipAmount}
                  </div>
                </div>
                <div className='row total-amount-section'>
                  <div className='col-md-10'>Subtotal</div>
                  <div className='col-md-2'>
                    {currency} {totalAmount + bill?.tipAmount}
                  </div>
                </div>
              </div>
            </div>
            <div className='row mt-5'>
              <div className='col-md-8'></div>
              <div className='col-md-4 order-delayed'>
                <div className='row'>
                  <div className='col-md-6'>
                    {bill?.orderStatus === 'Bill Requested' && (
                      <Button
                        variant={'contained'}
                        color='primary'
                        type='button'
                        onClick={() => handleBillPaid()}
                      >
                        Order Paid
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardBillView;
